import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NiComponentsModule } from '../../ni-components/ni-components.module';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    NiComponentsModule
  ],
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {
  constructor(private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    console.log('🚨 ForbiddenComponent loaded');
    console.log('🚨 Current URL:', this.router.url);
  }

  goHome() {
    console.log('Go Home button clicked');
    this.router.navigate(['/']);
  }

  goBack() {
    console.log('Go Back button clicked');
    this.location.back();
  }
}
